import { render } from "./ComponenteGasParametros.vue?vue&type=template&id=83b5f5b2&scoped=true"
import script from "./ComponenteGasParametros.vue?vue&type=script&lang=js"
export * from "./ComponenteGasParametros.vue?vue&type=script&lang=js"

import "./ComponenteGasParametros.vue?vue&type=style&index=0&id=83b5f5b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b5f5b2"]])

export default __exports__